import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AtlasTouchpoint } from '@scout24/is24-resi-agent-touchpoint';
import throttle from 'lodash/throttle';
import WidgetFrame from '../Utils/Widget/Frame/Frame.jsx';
import defaultTracking from '../../tracking/tracking.js';
import {
  getGeoId,
  getRealEstateType,
  getLocationNameForAgentTouchpoint,
  getPageViewId,
} from '../../selectors/selectors.js';
import CampaignParameters from '../Utils/Touchpoint/CampaignParameters';

export class AtlasTouchpointWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDataToShow: false,
      realtorCwid: null,
      reported: false,
    };
    this.elem = React.createRef();
    this.scrollListenerThrottled = throttle(this.scrollListener(this.state), 100);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollListenerThrottled);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollListenerThrottled);
  }

  isShown = (elem) => {
    if (!elem || !elem.current) {
      return false;
    }
    // Get element's bounding
    const bounding = elem.current.getBoundingClientRect();
    // Check if it's out of the viewport on each side
    const percentageVisibleArea = (bounding.height * 40) / 100;
    return bounding.top < window.innerHeight - percentageVisibleArea;
  };

  scrollListener = () => () => this.reportShownEvent();

  reportShownEvent = () => {
    const { tracking } = this.props;
    if (this.state.reported) {
      return;
    }

    if (this.state.hasDataToShow && this.isShown(this.elem)) {
      tracking.report(`atlas_${this.props.geoId}_${this.state.realtorCwid}_shown`, 'agent_touchpoints');
      this.setState({ reported: true });
    }
  };

  handleOnLoad = (widgetData) => {
    const { tracking } = this.props;
    tracking.reportData({
      label: `atlas_${this.props.geoId}_${widgetData.realtorCwid}_loaded`,
      action: 'agent_touchpoints',
      category: 'residential',
      pageTitle: this.props.pageTitle,
    });

    this.setState({
      realtorCwid: widgetData && widgetData.realtorCwid,
    });
    this.setState(
      {
        hasDataToShow: true,
      },
      () => this.reportShownEvent(),
    );
  };

  handleOnClick = (widgetData) => {
    const { tracking } = this.props;
    tracking.report(`atlas_${this.props.geoId}_${widgetData.realtorCwid}_clicked`, 'agent_touchpoints');
  };

  handleFallback = () => {
    this.setState({
      hasDataToShow: false,
    });
  };

  render() {
    const { hasDataToShow } = this.state;
    const { touchpointEnv } = this.props;
    const env = touchpointEnv;
    return (
      <div ref={this.elem} style={{ display: hasDataToShow ? 'block' : 'none' }}>
        <WidgetFrame>
          <AtlasTouchpoint
            env={env}
            searchType="geoId"
            clientId="is24-resi-property-book"
            geoIds={[this.props.geoId]}
            locationName={this.props.locationName}
            realEstateType={this.props.realEstateType}
            onLoad={this.handleOnLoad}
            onError={this.handleFallback}
            onClick={this.handleOnClick}
            onFallback={this.handleFallback}
            campaignParams={this.props.campaignParams}
          />
        </WidgetFrame>
      </div>
    );
  }
}

AtlasTouchpointWrapper.defaultProps = {
  geoId: null,
  realEstateType: null,
  locationName: null,
  touchpointEnv: null,
  tracking: defaultTracking,
  campaignParams: CampaignParameters,
  pageTitle: null,
};

AtlasTouchpointWrapper.propTypes = {
  geoId: PropTypes.string,
  realEstateType: PropTypes.string,
  locationName: PropTypes.string,
  touchpointEnv: PropTypes.string,
  tracking: PropTypes.object,
  campaignParams: PropTypes.object,
  pageTitle: PropTypes.string,
};

const mapStateToProps = (state) => ({
  geoId: getGeoId(state),
  realEstateType: getRealEstateType(state),
  locationName: getLocationNameForAgentTouchpoint(state),
  touchpointEnv: state.config.touchpointEnv,
  pageTitle: getPageViewId(state),
});

export default connect(mapStateToProps)(AtlasTouchpointWrapper);
